"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmallExpandableCard = void 0;
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const FeatureIcon_1 = __importDefault(require("../../FeatureIcon/FeatureIcon"));
const Icon_1 = __importDefault(require("../../Icon/Icon"));
const SmallExpandableCard = (props) => {
    const [open, setOpen] = React.useState(props.isOpenOnRender ? props.isOpenOnRender : false);
    const toggleOpen = () => {
        if (props.onClick) {
            props.onClick();
        }
        setOpen((old) => !old);
    };
    const classNameContainer = classnames_1.default({
        'expandable-card': true,
        'expandable-card-blue': true,
        'expandable-card-open': open,
        'expandable-card-rounded-corners': props.roundedCorners,
        'expandable-card-small': true,
    });
    const classNameBody = classnames_1.default({
        'expandable-card-body': true,
        'scrollable-card-small': props.contentMaxHeight,
    });
    return (React.createElement("div", { className: classNameContainer },
        React.createElement("div", { className: "header", onClick: toggleOpen },
            React.createElement("div", { className: "header-inner" },
                props.icon && React.createElement(FeatureIcon_1.default, { icon: props.icon, color: "blue" }),
                React.createElement("h4", null, props.title)),
            React.createElement("div", { className: "toggle-icon" },
                React.createElement(Icon_1.default, { icon: open ? 'arrow_up' : 'arrow_down' }))),
        open && (React.createElement("div", { className: classNameBody, style: { maxHeight: props.contentMaxHeight } }, props.children))));
};
exports.SmallExpandableCard = SmallExpandableCard;
//# sourceMappingURL=SmallExpandableCard.js.map